<template>
    <div 
    :style="{ backgroundImage: 'url(' + background + ')'}"
    class="container-fluid pt-4" id="con-survey">

        <b-container>
            <HMenu v-if="!(user.role === '230' || user.role === '039' || user.role === '056')" />
            <div id='headerColab' class="center text-white pt-3 pb-4 pl-4 ">
                <p class="stylingH1 pb-3"> Buzón</p>
            </div>
            <b-row>                
                <b-col class="bg-gris py-4 px-5" >              
                    <div class="row pager">
                        <div v-for="(question, index) in quiz.questions" :key="question.id">
                            <div v-if="index === questionIndex">
                                <p>0{{index + 1}} / 05</p>
                            </div>
                        </div>                        
                    </div>
                    <p v-if="errors" class="alert alert-danger mb-0">
                            {{ error_msg }}
                    </p>
                    <div class="row question">
                        <div v-for="(question, index) in quiz.questions" :key="question.id">
                            <div v-if="index === questionIndex">
                            
                                <h4 class="my-5 px-3">{{ question.text }}</h4>                                 
                                <div v-for="answer in question.answers" :key="answer.id" class="selectionButtons">
                                    <template v-if="answer.text === 'libre'">
                                        <b-form-textarea
                                        class="p-2 textArea"
                                        id="textarea"
                                        v-model="responses[index]"
                                        rows="3"
                                        max-rows="6"
                                        ></b-form-textarea>
                                    </template>
                                    <template v-else>  
                                        <template v-if="eleccion == false && indexSelected == ''">
                                            <label @click="SET_PICKED(true), SET_INDEX(answer.text)"
                                            :class="['form-check-label', 'formChek',{ 'blueColor' : answer.text == 'Si' , 'orangeColor' : answer.text == 'No'}]">
                                                <input type="radio" class="form-check-input"
                                                    :value="answer.value"                                                
                                                    :name="index"                                                                                                                                                 
                                                    v-model="responses[index]">
                                                <label mb-0>{{answer.text}} <img v-if="answer.text == 'Si'" :src="yesIcon" class="btn-icon ml-2"><img v-if="answer.text == 'No'" :src="noIcon" class="ml-2 btn-icon"></label>
                                            </label>
                                        </template>
                                        <template v-else>
                                            <template v-if="indexSelected == 'Si'">
                                                <label @click="SET_PICKED(true), SET_INDEX(answer.text)"
                                                :class="['form-check-label', 'formChek',{ 'orangeColor' : answer.text == 'Si' , 'whiteColor' : answer.text == 'No'}]">
                                                    <input type="radio" class="form-check-input"
                                                        :value="answer.value"                                                
                                                        :name="index"                                                                                                                                                 
                                                        v-model="responses[index]">
                                                    <label>{{answer.text}} <img v-if="answer.text == 'Si'" :src="yesIcon" class="btn-icon ml-2"><img v-if="answer.text == 'No'" :src="noIcon" class="ml-2 btn-icon"></label>
                                                </label>
                                            </template>
                                            <template v-else>
                                                 <label @click="SET_PICKED(true), SET_INDEX(answer.text)"
                                                :class="['form-check-label', 'formChek',{ 'whiteColor' : answer.text == 'Si' , 'orangeColor' : answer.text == 'No'}]">
                                                    <input type="radio" class="form-check-input"
                                                        :value="answer.value"                                                
                                                        :name="index"                                                                                                                                                 
                                                        v-model="responses[index]">
                                                    <label>{{answer.text}} <img v-if="answer.text == 'Si'" :src="yesIcon" class="btn-icon ml-2"><img v-if="answer.text == 'No'" :src="noIcon" class="ml-2 btn-icon"></label>
                                                </label>
                                            </template>
                                        </template>                 
                                    </template>  
                                </div>
                                
                                
                            </div>
                        </div>                        
                    </div>
                    <div v-if="questionIndex < (quiz.questions.length - 1)" class="mt-3">
                        <button class="btn btn-next float-right" @click="next">
                            <img :src="nextIcon" class="icon-next">
                        </button>  
                    </div>
                    <div v-else-if="questionIndex === (quiz.questions.length - 1)" class="mt-3">
                        <button
                            @click="send(responses)"
                            :class="['btn w-100', { 'saved' : sendFlag, 'btn-send' : sendFlag == false }]">
                            <img v-if="sendFlag" :src="check" class="icon mb-1 mr-1" /> {{textButton}}
                        </button>
                    </div>

                    <div v-if="questionIndex === quiz.questions.length">
                        <h3>Gracias por tus opiniones!</h3>
                        <button class="btn btn-secondary center" @click="finish()">
                            Salir
                        </button> 
                    </div>
                    
                </b-col>
                <Footer v-if="!(user.role === '230' || user.role === '039' || user.role === '056')"
                :user="user"
                />
            </b-row>
        </b-container>   
    </div>
</template>

<script>

import img from '../assets/fondoazul.png';
import Footer from '../components/Footer';
import i_si from '../assets/icono_si.png';
import i_no from '../assets/icono_no.png';
import i_next from '../assets/flecha.png';
import {mapMutations} from 'vuex';
import HMenu from '../components/HeaderIcons';
import check from '../assets/icono_check.png';
import userService from '../services/user.service'

let quiz = {
  questions: [
    {
        text: '¿Estas orgulloso de pertenecer al grupo FANOSA?',
        answers: [
            {
                text: 'Si',
                value: 1
            },
            {
                text: 'No',
                value: 0
            },
        ]
    },
    {
        text: '¿Tienes buena comunicación con tus compañeros del área?',
        answers: [
            {
                text: 'Si',
                value: 1
            },
            {
                text: 'No',
                value: 0
            },
        ]
    },
    {
        text: '¿Tu jefe te apoya e impulsa a que desempeñes tu trabajo de forma más eficiente?',
        answers: [
            {
                text: 'Si',
                value: 1
            },
            {
                text: 'No',
                value: 0
            },
        ]
    },
    {
        text: '¿Te gustan las actividades que desempeñas?',
        answers: [
            {
                text: 'Si',
                value: 1
            },
            {
                text: 'No',
                value: 0
            },
        ]
    },
    {
        text: 'Alguna sugerencia o comentario que quieras expresar (libre) ',
        answers: [
            {
                text: 'libre',
            },
        ]
    },
  ]
};

export default {
    name: 'Survey',
    components: {Footer, HMenu},
    props:{
        user : {
            required: true,
        }
    },
    data() {
        return {
            background: img,
            yesIcon: i_si,
            noIcon: i_no,
            nextIcon: i_next,
            quiz: quiz,
            questionIndex: 0,
            responses: [],
            error_msg: '',
            check: check,
        }
    },
    created() {
        this.$store.dispatch("admin/week");
    },
    async beforeMount() {
        let token = await this.$store.dispatch("userService/getToken");
        this.$store.dispatch("userService/decode", token);
    }, 
    computed:{
        week() {
            return this.$store.getters["admin/getWeek"];
        },
        user() {            
            return this.$store.getters['userService/getIdentity'];
        },
        errors() {
            return this.$store.getters['plants/getsurveyError'];
        },
        eleccion() {
            return this.$store.getters['plants/getpickedAnswer'];
        },
        indexSelected() {
            return this.$store.getters['plants/getchoice'];
        },
        sendFlag() {
            return this.$store.getters['plants/sendFlag'];
        },
        textButton() {
            return this.$store.getters['plants/sendText'];
        },
        identity() {
             return this.$store.getters['userService/getIdentity'];
        },
    dataUrl(){
         let token = userService.getToken();
         let identity = userService.decode(token);},
    },
    filters:{
        split: (value) => {
            if (!value) return '';
            value = value.toString();

            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i;
            
            for ( i = 0; i < len; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            let newName = nameCap.split(' ').slice(0, -1).join(' ')

            return newName;
        },
        rand: (value) => {
            if (!value || value < 0) return '0';
            if (typeof value === 'number') {
                return value.toFixed(2);
            }
            return value;
        },
        cap: (value)=>{
            if (!value) return '';
            value = value.toString();
            
            let splitStr = value.toLowerCase().split(' ');
            let len = splitStr.length
            let i; 
            for ( i = 0; i < len; i++) {
                splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);     
            }
            let nameCap = splitStr.join(' '); 
            return nameCap;
        }
    },
    methods: { 
        ...mapMutations('plants', ['SET_PICKED']),
        ...mapMutations('plants', ['SET_INDEX']),
        next: function() {
            if (this.responses[this.questionIndex] === undefined && this.questionIndex < 4 ) {                
                this.error_msg = 'Selecciona tu respuesta';
                this.$store.dispatch("plants/surveyError", true);
            } 
            else {    
                this.$store.dispatch("plants/surveyError", false); 
                this.$store.dispatch("plants/pickedAnswer", false);
                this.$store.dispatch("plants/setSelectedIndex", '');             
                this.questionIndex++;
            } 
        },
        send: function(responses){
            this.$store.dispatch('plants/sendSurveyInfo', {
                surveyAnswers: responses,
                uid: 'xxx' ,
                text: 'Envío exitoso',
                flag: true               
            });
            this.wait();
        },
        wait: function(){
            setTimeout(() => this.next(), 1000);
        },       
        finish: function() {
            //this.questionIndex = 0;
            //this.$store.dispatch('userService/setStatusSurvey','yes');
            let sv = localStorage.getItem('survey');
            if(sv !=null){
                localStorage.removeItem('survey');
                localStorage.setItem('survey', 'yes')
            }else{
                localStorage.setItem('survey', 'yes')
            }
            
            let token = userService.getToken();
            let identity = userService.decode(token);
            this.$router.push(`/${identity.city}/${identity.depto}/${identity.num}`);
        },
    }
    
}
</script>
<style scoped>
.pager{
    color: #aaaaaa;
    font-family: 'FuturaPTDemi';
}
.question h4, h3{
    font-family: 'FuturaPTDemi';
    font-size: 2rem;
    color: #838383;
}
.btn-icon{
    max-width: 1.5rem;
}
.icon-next{
    max-width: 2.5rem;    
}
.btn-next{
    background-color: transparent;
    border: none;
}
.btn-next:focus{
    outline: none;
    box-shadow: none;
}
.btn-send{
    border-radius: 30px;
    color: white;
    background-color: #4d78e7;
    border-color: #4d78e7;
    font-size: 13px;
    padding: 1rem 0;
}
.btn-send:hover{
    background-color: #3b63c9;
    border-color: #3b63c9;
}
.btn-send:focus{
    outline: none;
}
.saved{
    background-color: #ecf0f6;
    border: 1px solid #3b63c9;
    color: #3b63c9;
    border-radius: 30px;
    font-size: 13px;
    padding: 1rem 0;
}
.icon{
    max-width: 1rem;
    cursor: pointer;
}
.formChek{
    position: relative;
    display: block;
    padding-left: 1.25rem;
}
.selectionButtons {
    margin-bottom: 1rem;
}
.selectionButtons input[type="radio"] {
    opacity:0.011;
    z-index:100;
}
.selectionButtons .blueColor{
    text-align: center;
    padding: 16px;    
    border-radius: 30px;
    background-color:#456ed5; 
    cursor: pointer;
    color: white;
    font-family: 'FuturaPTDemi';
    font-size: 1.2rem;
    /*z-index:90;*/
}
.selectionButtons .orangeColor{
    text-align: center;
    padding: 16px;
    border-radius: 30px;
    background-color: #ff9d3e; 
    cursor: pointer;
    color: white;
    font-family: 'FuturaPTDemi';
    font-size: 1.2rem;
    /*z-index:90;*/
}
.selectionButtons .whiteColor{
    text-align: center;
    padding: 16px;
    border-radius: 30px;
    background-color: #ffffff; 
    cursor: pointer;
    color: black;
    font-family: 'FuturaPTDemi';
    font-size: 1.2rem;
    z-index:90;
}
.selectionButtons .blueColor:hover {
    background-color: #3b63c9;
}
.selectionButtons .orangeColor:hover {
    background-color: #fa932c;
}
.selectionButtons .whiteColor:hover {
    background-color: #fcfcff;
}
</style>